// react
import React from "react";
// icons
import { IconMapPin, IconPhone, IconPhoto, IconUser } from "@tabler/icons-react";
// link
import { Link } from "react-router-dom";

const PhotographerProjects = () => {

    return (
        <>
            <section>
                {/* admin page component */}
                <div className={'admin-page-content mb-3 pt-0'}>
                    <div id={'admin-page-form'}>
                        <p className={'fw-bold box-title'}>لیست پروژه های محول شده</p>
                        <div className={'card card-body shadow border-0'}>
                            <div className="row gy-4">
                                {Array.from({ length: 5 }, (_, index) => (
                                    <>
                                        <div key={index + 'slider'} className="col-md-4">
                                            <div className='card card-body rounded rounded-4 border-0 shadow'>
                                                <img className='img-fluid rounded rounded-3' alt='amlak' src={require('./../../../assets/media/backgrounds/background.webp')} />
                                                <p className='h5 fw-bold card-title mb-2 mt-3'>
                                                    خانه ویلایی تبریز
                                                </p>
                                                <ul className="list-group list-group-flush px-0">
                                                    <li className="list-group-item px-0">
                                                        <IconUser size={14} className='align-middle me-1' />
                                                        مهدی محمد زاده
                                                    </li>
                                                    <li className="list-group-item px-0">
                                                        <IconPhone size={14} className='align-middle me-1' />
                                                        09205651382
                                                    </li>
                                                    <li className="list-group-item px-0">
                                                        <IconMapPin size={14} className='align-middle me-1' />
                                                        شهرزاد ، جنب پاساژ اطلس
                                                    </li>
                                                    <li className="list-group-item px-0">
                                                        <IconPhoto size={14} className='align-middle me-1' />
                                                        عکاسی 360 درجه + ساده
                                                    </li>
                                                </ul>
                                                <Link to={'/photographer/panel/projects/uploads/2'} className="btn btn-outline-primary mt-2">
                                                    بار گذاری عکس
                                                </Link>
                                            </div>
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default PhotographerProjects;